// extracted by mini-css-extract-plugin
module.exports = {"root":"src-components-page-portfolio-portfolio-detail-CasePage-module__root--cDYSm"};